(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pay-later-widget"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('paylater-widget')) {
    class PayLaterWidget extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId || '';
        this.cartTotal = Number(this.dataset.cartTotal || 0);
        this.variantPrice = Number(this.dataset.variantPrice || 0);
        this.minOrder = Number(this.dataset.minOrder || 0);
        this.maxOrder = Number(this.dataset.maxOrder || 0);
        this.installments = Math.max(1, Number(this.dataset.installments || 4));
        this.moneyFormat = this.dataset.moneyFormat || '{{amount}}';
        this.locale = this.dataset.locale || 'en';

        this.quantityInput = this.sectionId
          ? document.getElementById(`Quantity-${this.sectionId}`)
          : null;

        if (!this.quantityInput) {
          this.quantityInput = this.closest('section')?.querySelector('[name="quantity"]') || null;
        }

        this.dialog = this.querySelector('[data-paylater-dialog]');
        this.openButtons = this.querySelectorAll('[data-paylater-open]');
        this.closeButtons = this.querySelectorAll('[data-paylater-close]');

        this.onQuantityChange = this.update.bind(this);
        this.onOpen = this.openDialog.bind(this);
        this.onClose = this.closeDialog.bind(this);

        this.quantityInput?.addEventListener('input', this.onQuantityChange);
        this.quantityInput?.addEventListener('change', this.onQuantityChange);
        this.openButtons.forEach((button) => button.addEventListener('click', this.onOpen));
        this.closeButtons.forEach((button) => button.addEventListener('click', this.onClose));

        this.update();
      }

      disconnectedCallback() {
        this.quantityInput?.removeEventListener('input', this.onQuantityChange);
        this.quantityInput?.removeEventListener('change', this.onQuantityChange);
        this.openButtons?.forEach((button) => button.removeEventListener('click', this.onOpen));
        this.closeButtons?.forEach((button) => button.removeEventListener('click', this.onClose));
      }

      getQuantity() {
        const value = Number(this.quantityInput?.value || 1);
        return Number.isFinite(value) && value > 0 ? value : 1;
      }

      update() {
        const quantity = this.getQuantity();
        const lineTotal = this.variantPrice * quantity;
        const projectedTotal = this.cartTotal + lineTotal;
        const overMax = this.maxOrder > 0 && projectedTotal > this.maxOrder;
        const eligible = projectedTotal >= this.minOrder && !overMax;
        const payment = Math.round(lineTotal / this.installments);
        const formattedPayment = this.formatMoney(payment);
        const formattedProjected = this.formatMoney(projectedTotal);
        const amountToMin = Math.max(0, this.minOrder - projectedTotal);
        const formattedAmountToMin = this.formatMoney(amountToMin);
        const formattedMin = this.formatMoney(this.minOrder);

        this.classList.toggle('is-eligible', eligible);
        this.classList.toggle('is-under-min', !eligible && !overMax);
        this.classList.toggle('is-over-max', overMax);

        this.querySelectorAll('[data-paylater-amount], [data-paylater-step-amount]').forEach((node) => {
          node.textContent = formattedPayment;
        });

        const statusIcon = this.querySelector('[data-paylater-status-icon]');
        if (statusIcon) statusIcon.textContent = eligible ? '✓' : '×';

        const statusMin = this.querySelector('.paylater-widget__status-min');
        const statusMax = this.querySelector('.paylater-widget__status-max');
        if (statusMin) statusMin.hidden = overMax;
        if (statusMax) statusMax.hidden = !overMax;

        const detail = this.querySelector('[data-paylater-eligibility-detail]');
        if (detail) {
          const isArabic = (this.dataset.locale || '').toLowerCase().startsWith('ar');

          if (overMax) {
            detail.innerHTML = isArabic
              ? `× إجمالي الطلب المتوقع <strong>${formattedProjected}</strong> يتجاوز الحد المسموح.`
              : `× Projected order <strong>${formattedProjected}</strong> is above the allowed limit.`;
          } else if (eligible) {
            detail.innerHTML = isArabic
              ? `✓ إجمالي الطلب المتوقع <strong>${formattedProjected}</strong> مؤهل.`
              : `✓ Projected order <strong>${formattedProjected}</strong> is eligible.`;
          } else {
            detail.innerHTML = isArabic
              ? `× إجمالي الطلب المتوقع <strong>${formattedProjected}</strong> — أضف <strong>${formattedAmountToMin}</strong> للوصول إلى ${formattedMin}.`
              : `× Projected order <strong>${formattedProjected}</strong> — add <strong>${formattedAmountToMin}</strong> to reach ${formattedMin}.`;
          }
        }
      }

      openDialog() {
        if (!this.dialog) return;
        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }
      }

      closeDialog() {
        if (!this.dialog) return;
        if (typeof this.dialog.close === 'function') {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute('open');
        }
      }

      formatMoney(cents) {
        const format = this.moneyFormat || '{{amount}}';
        const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
        const token = match ? match[1] : 'amount';
        let value;

        switch (token) {
          case 'amount_no_decimals':
            value = this.withDelimiters(cents, 0, ',', '.');
            break;
          case 'amount_with_comma_separator':
            value = this.withDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = this.withDelimiters(cents, 0, '.', ',');
            break;
          case 'amount_with_space_separator':
            value = this.withDelimiters(cents, 2, ' ', ',');
            break;
          case 'amount_no_decimals_with_space_separator':
            value = this.withDelimiters(cents, 0, ' ', ',');
            break;
          case 'amount_with_apostrophe_separator':
            value = this.withDelimiters(cents, 2, "'", '.');
            break;
          default:
            value = this.withDelimiters(cents, 2, ',', '.');
        }

        return match ? format.replace(match[0], value) : value;
      }

      withDelimiters(cents, precision, thousands, decimal) {
        const number = (Number(cents || 0) / 100).toFixed(precision);
        const parts = number.split('.');
        const whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
        return precision > 0 ? `${whole}${decimal}${parts[1]}` : whole;
      }
    }

    customElements.define('paylater-widget', PayLaterWidget);
  }
  } catch(e) { console.error(e); }
})();

})();
